<!--
  PBA Layout Template Component Picker - Different styles
-->

<template>
  <component :is="(website_data.profile.template_name || 'LSBD') + 'Layout'" />
</template>

<script>
  export default {
    components: {
      LSBDLayout: () => import('@/layouts/LSBD/Index'),
      BBRCLayout: () => import('@/layouts/BBRC/Index'),
      DARALayout: () => import('@/layouts/DARA/Index'),
      OCEANLayout: () => import('@/layouts/OCEAN/Index')
      // Future templates here
    },
  }
</script>
